<script setup>
import { computed } from 'vue';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, createdAt } = useMessageContext();

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, HH:mm')
);
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-2.5 py-0.5 !rounded-xl flex min-w-0 items-center gap-2 !text-xs text-center"
    data-bubble-name="activity"
  >
    <span v-dompurify-html="content" :title="content" />
  </BaseBubble>
</template>
